<div class="d-flex flex-column h-100">
    <div class="flex-fill" style="display: flex; align-items:center">
        <canvas baseChart *ngIf="chartConfig"
            [type]="chartConfig.type"
            [datasets]="chartConfig.data.datasets"
            [labels]="chartConfig.data.labels"
            [options]="chartConfig.options"
            class="mx-auto w-100">
        </canvas>
    </div>
</div>